var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.view == 'facturacion')?_c('div',[_c('list-sales')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }